import React from 'react';
import styled from 'styled-components';

type TextShellProps = {
  children?: React.ReactNode;
  size?: 'sm' | 'md' | 'lg';
};

const Loading = styled.div`
  background-color: var(--color-text-quote-10);
  border-radius: 5px;
  height: 1em;

  &.size-sm {
    width: 80px;
  }

  &.size-md {
    width: 120px;
  }

  &.size-lg {
    width: 160px;
  }
`;

export function TextShell(props: TextShellProps) {
  const { size = 'md' } = props;
  const sizeClassName = `size-${size}`;

  return <>{props.children || <Loading className={sizeClassName} />}</>;
}
